function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';
import { TYPE_RADIO, TYPE_CHECKBOX } from '../constants';
/**
The ChoiceButton display a checkbox or a radio button and adds relevant css styles based on props. Most often ChoiceButton is rendered by RadioGroup or CheckboxGroup, but sometimes it makes sense to display a single checkbox which can be done by calling ChoiceButton directly.
Any unrecognized prop will be passed into the native `<input />` so one can add any additional information as necessary.

Example:
```
<ChoiceButton type="radio" value="yes" name="yesOrNoForm" />
<ChoiceButton type="checkbox" value="cat" name="animals" />
<ChoiceButton type="checkbox" value="cat" name="animals" checked={true} />
<ChoiceButton type="checkbox" value="cat" name="animals" onChange={() => {console.log('changed')}} />
<ChoiceButton type="checkbox" value="cat" name="animals" title="Cat" />
<ChoiceButton type="checkbox" value="cat" name="animals" description="A small household pet" />
<ChoiceButton type="checkbox" value="cat" name="animals" id="animals-1" />
```
*/

function ChoiceButton(_ref) {
  var _rowClassNames, _inputClassNames;

  var className = _ref.className,
      value = _ref.value,
      type = _ref.type,
      name = _ref.name,
      checked = _ref.checked,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      id = _ref.id,
      title = _ref.title,
      description = _ref.description;
  var btnId = id || name;
  var rowClassNames = (_rowClassNames = {}, _defineProperty(_rowClassNames, styles.radio, type === TYPE_RADIO), _defineProperty(_rowClassNames, styles.ww, true), _defineProperty(_rowClassNames, styles.checkbox, true), _defineProperty(_rowClassNames, className, true), _rowClassNames);
  var inputClassNames = (_inputClassNames = {}, _defineProperty(_inputClassNames, styles.input, true), _defineProperty(_inputClassNames, styles.selected, checked), _inputClassNames);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(rowClassNames)
  }, /*#__PURE__*/React.createElement("input", {
    type: type,
    className: cx(inputClassNames),
    id: btnId,
    value: value,
    name: name,
    checked: checked,
    disabled: disabled,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("label", {
    className: styles.label,
    htmlFor: btnId
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, title || value), description && /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, description)));
}

ChoiceButton.defaultProps = {
  checked: false,
  disabled: false,
  onChange: function onChange() {}
};
ChoiceButton.propTypes = {
  /**
  input's value
  */
  value: PropTypes.any.isRequired,

  /**
  The input's name, should be the same for type=checkbox
  */
  name: PropTypes.string.isRequired,

  /**
  Checked
  */
  checked: PropTypes.bool,

  /**
  Disables the input (will not change styling)
  */
  disabled: PropTypes.bool,

  /**
  Callback function when un/checked
  */
  onChange: PropTypes.func,

  /**
  Title
  */
  title: PropTypes.node,

  /**
  Description
  */
  description: PropTypes.node,

  /**
  radio or checkbox
  */
  type: PropTypes.oneOf([TYPE_RADIO, TYPE_CHECKBOX]).isRequired,

  /**
  Unique DOM id
  */
  id: PropTypes.string
};
export default ChoiceButton;